export default {
  entities: null,
  financingTerms: {
    isLoading: true,
    error: {}
  },
  termsOverview: {
    isLoading: true,
    error: {},
    overview: null
  }
};
